export const menuItems = [
  {
    label: "Quem sou",
    path: "#about_me",
  },
  {
    label: "Projetos",
    path: "#projects",
  },
  {
    label: "Habilidades",
    path: "#skills",
  },
  {
    label: "Conhecimentos",
    path: "#conhecimentos",
  },
];
